import './assets/fonts/plus-jakarta-sans/plus-jakarta-sans.css';
import './assets/css/tokens.css';
import './assets/css/global.css';
import { Outlet, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { ConsentProvider } from './consent/ConsentProvider';
import LanguageManager from './i18n/LanguageManager';
import About from './routes/About';
import Ai from './routes/Ai';
import AppAds from './routes/AppAds';
import Contact from './routes/Contact';
import Home from './routes/Home';
import Legal from './routes/Legal';
import NotFound from './routes/NotFound';
import Project from './routes/Project';
import Services from './routes/Services';
import Support from './routes/Support';
import Work from './routes/Work';

export default function App() {
    return (
        <ConsentProvider>
            <LanguageManager />
            <ScrollToTop />
            <Routes>
                <Route element={<Layout><Outlet /></Layout>}>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/work" element={<Work />} />
                    <Route path="/work/:slug" element={<Project />} />
                    <Route path="/ai" element={<Ai />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/support" element={<Support />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/imprint" element={<Legal documentKey="imprint" />} />
                    <Route path="/privacy-policy" element={<Legal documentKey="privacy" />} />
                    <Route path="/terms-of-service" element={<Legal documentKey="terms" />} />
                    <Route path="/cookie-policy" element={<Legal documentKey="cookie" />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
                <Route path="/app-ads.txt" element={<AppAds />} />
            </Routes>
        </ConsentProvider>
    );
}
